var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 44,
    viewBox: "0 0 71 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.8579 41.2861C37.8221 41.2861 25.1442 43.1318 13.4964 39.1079C5.95816 36.5038 -1.41537 27.7289 3.69473 19.6603C7.46629 13.7052 14.4195 8.34898 20.9198 5.59128C26.1797 3.35981 31.6654 3.2813 37.1892 2.56855C45.7694 1.46143 55.7741 1.55568 63.1268 6.70257C67.5036 9.76636 69.0611 12.4221 69.0611 17.7044C69.0611 21.1575 67.5075 24.1488 64.2603 25.7724C60.7455 27.5298 57.6329 29.974 54.2364 31.8845C51.178 33.6049 48.7417 36.1696 45.3683 37.3743C44.2914 37.7589 41.1293 38.74 40.6564 39.6858",
    stroke: "#4293E3",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelected);
export default __webpack_public_path__ + "static/media/selected.321595cdbd8b9eb37e63433a57819d45.svg";
export { ForwardRef as ReactComponent };